import React, { useState } from 'react';
import { CButton } from '@coreui/react';
import AceEditor from 'react-ace';
import 'ace-builds/src-noconflict/mode-json';
import 'ace-builds/src-noconflict/theme-monokai';
import { callTokenApi } from '../../../../apiCaller';
import { toast } from 'react-toastify';
import CIcon from '@coreui/icons-react';
import { cilCopy, cilCheckCircle } from '@coreui/icons';

const sampleJson = {
     label: 'acc=134b6d31-aa6c-4f46-b9bd-e62e662933aa&s=911e34c5-b3cd-4974-a8d1-f6407a594452',
     target_email: 'thewieders@gmail.com',
     postal_address: {
          zip: '33433-7457',
          address: '7369 ORANGEWOOD LN APT 305',
          city: 'BOCA RATON',
          last_name: 'WIEDER',
          state: 'FL',
          first_name: 'STEPHANIE',
     },
};

const ScriptEditor = () => {
     const [script, setScript] = useState('');
     const [isRunning, setIsRunning] = useState(false);
     const [scriptResult, setScriptResult] = useState('');
     const [copiedScript, setCopiedScript] = useState(false);

     const handleLoadSample = () => {
          setScript(JSON.stringify(sampleJson, null, 4));
     };

     const handleBeautifyJson = () => {
          try {
               // Try to parse the script as JSON
               const parsed = JSON.parse(script);
               // Format it with 4-space indentation
               const beautified = JSON.stringify(parsed, null, 4);
               setScript(beautified);
          } catch (error) {
               toast.error('Invalid JSON format. Please check your syntax.');
          }
     };

     const handleCopyScript = async () => {
          try {
               await navigator.clipboard.writeText(script);
               setCopiedScript(true);
               setTimeout(() => setCopiedScript(false), 2000);
          } catch (error) {
               toast.error('Failed to copy to clipboard');
          }
     };

     const handleClearEditor = () => {
          setScript('');
          setScriptResult('');
     };

     const handleRunScript = async () => {
          setIsRunning(true);
          setScriptResult('');

          try {
               const response = await callTokenApi('admin/centralized-person/execute-script', 'POST', { script });
               if (response.status === 200) {
                    toast.success('Sent successfully!');
                    setScriptResult(response.data.result);
               } else {
                    toast.error(response);
               }
          } catch (error) {
               console.error('API call failed:', error);
               toast.error('An unexpected error occurred while executing the script.');
          } finally {
               setIsRunning(false);
          }
     };
     return (
          <>
               <div className='d-flex justify-content-end align-items-center mb-4'>
                    <div className='d-flex align-items-center gap-2'>
                         <CButton
                              size='sm'
                              color='secondary'
                              variant='outline'
                              onClick={handleLoadSample}
                              className='d-flex align-items-center justify-content-center'
                              style={{ height: '32px', minWidth: '100px' }}
                         >
                              Load Sample
                         </CButton>
                         <CButton
                              size='sm'
                              color='info'
                              variant='outline'
                              onClick={handleBeautifyJson}
                              disabled={!script.trim()}
                              className='d-flex align-items-center justify-content-center'
                              style={{ height: '32px', minWidth: '100px' }}
                         >
                              Beautify JSON
                         </CButton>
                         <CButton
                              size='sm'
                              color='success'
                              variant='outline'
                              onClick={handleCopyScript}
                              disabled={!script.trim()}
                              className='d-flex align-items-center justify-content-center'
                              style={{ height: '32px', minWidth: '100px', transform: 'unset' }}
                         >
                              <CIcon icon={copiedScript ? cilCheckCircle : cilCopy} className='me-2' />
                              {copiedScript ? 'Copied!' : 'Copy JSON'}
                         </CButton>
                         <CButton
                              size='sm'
                              color='danger'
                              variant='outline'
                              onClick={handleClearEditor}
                              disabled={!script.trim() && !scriptResult}
                              className='d-flex align-items-center justify-content-center'
                              style={{ height: '32px', minWidth: '80px' }}
                         >
                              Clear
                         </CButton>
                    </div>
               </div>

               <AceEditor
                    mode='json'
                    theme='monokai'
                    name='scriptEditor'
                    onChange={setScript}
                    value={script}
                    showPrintMargin={false}
                    editorProps={{ $blockScrolling: true }}
                    setOptions={{
                         enableBasicAutocompletion: true,
                         enableLiveAutocompletion: true,
                         enableSnippets: true,
                         showLineNumbers: true,
                         tabSize: 4,
                         useWorker: false,
                    }}
                    fontSize={14}
                    lineHeight={20}
                    style={{ width: '100%', height: '300px' }}
               />

               <div className='d-flex justify-content-end mt-3'>
                    <CButton color='primary' onClick={handleRunScript} disabled={isRunning || !script.trim()}>
                         {isRunning ? 'Sending...' : 'Send'}
                    </CButton>
               </div>
          </>
     );
};

export default ScriptEditor;
